import React, { useEffect } from 'react';
import loadBackgroudImages from '../../common/loadBackgroudImages';

function PageHero({
  title,
  accent,
  subtitle,
  description,
  ctaText,
  ctaHref,
  background = '/assets/imgs/background/bg10.jpg',
}) {
  useEffect(() => {
    loadBackgroudImages();
  }, [background]);

  return (
    <header
      className="header-personal valign bg-img"
      data-background={background}
      data-overlay-dark="2"
    >
      <div className="container ontop">
        <div className="row">
          <div className="col-lg-8">
            <div className="caption">
              {subtitle && (
                <h6 className="sub-title mb-20 opacity-7 text-uppercase">
                  {subtitle}
                </h6>
              )}
              <h1 className="fw-700 mb-15">
                {title}
                {accent ? <span className="main-color"> {accent}</span> : null}
              </h1>
              {description ? (
                <div className="text mt-25">
                  <p>{description}</p>
                </div>
              ) : null}
              {ctaText && ctaHref ? (
                <div className="d-flex align-items-center mt-40">
                  <a href={ctaHref} className="butn butn-md butn-bord radius-30">
                    <span className="text">{ctaText}</span>
                  </a>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default PageHero;


